const FREE_ITEMS = {
  KNIFE: {
    id: "knife",
    name: "Knife set of 3",
    quantity: 1,
    image: require("./productImage/kitchenknife.jpg")
  },
  LIGHTER: {
    id: "lighter",
    name: "Gas Lighter",
    quantity: 1,
    image: require("./productImage/gaslighter.png")
  }
};

const products = [
  // PNG Stove - Consolidated with Glass Top and Stainless Steel variations
  {
    id: "png-stove",
    baseTitle: "PNG Stove",
    baseCategory: "png-stoves",
    baseDescription: "Premium PNG stoves available in toughened glass top and stainless steel variants. Perfect for modern kitchens with multiple burner configurations.",
    baseImage: require("./productImage/4 burner glasstop - PNG/1.jpeg"),
    variations: [
      // Glass Top Variations
      {
        sku: "GT002",
        title: "Glass Top - Dual Burner",
        material: "Glass Top",
        flipkartUrl: "https://www.flipkart.com/realflame-burner-glass-top-gas-stove-manual-ignition/p/itmd18aded060508?pid=GSTGM6WAHJRWCURX&lid=LSTGSTGM6WAHJRWCURXKLVYTL",
        burnerCount: 2,
       
        mrp: 4999,
        rating: 4.5,
        reviews: 12,
        description: `PNG stove with toughened glass top featuring dual burners. Durable construction with Manual Valve options. Perfect for modern kitchens.`,
        freeItems: [FREE_ITEMS.LIGHTER],
        images: [
          require("../assets/2B/02.webp"),
          require("../assets/2B/01.webp"),
          require("../assets/2B/03.webp"),
          require("../assets/2B/04.webp"),
          require("../assets/2B/05.webp"),
          require("../assets/2B/06.webp"),
          require("../assets/2B/07.webp"),
          require("../assets/2B/08.webp"),
          require("../assets/2B/09.webp"),
          require("../assets/2B/10.webp"),
          require("../assets/2B/011.webp"),
          require("../assets/2B/12.webp")
        ],
        specs: [
          { label: "Material", value: "Toughened Glass Top" },
          { label: "Frame Thickness", value: "0.6 mm" },
          { label: "Frame Dimension", value: "660mm x 330mm x 105mm" },
          { label: "Gas Pipe", value: "16 Gauge MS Pipe" },
          { label: "Gas Cock", value: "Manual Valve" },
          { label: "Pan Support", value: "240gm Powder Coated" },
          { label: "Brass Burner Top", value: "1 Big Burner 230gm & 1 Small Burner 170gm" },
          { label: "Mixing Tube", value: "1 Big Tube 235gm & 1 Small Tube 210gm" },
          { label: "Dip Tray", value: "60gm each" },
          { label: "Leg Bush", value: "40mm" }
        ]
      },
      {
        sku: "GT003",
        title: "Glass Top - Three Burner",
        material: "Glass Top",
        flipkartUrl: "https://www.flipkart.com/realflame-burner-glass-top-gas-stove-manual-ignition/p/itmfca0d24207c08?pid=GSTGM6WSTRJHZU9F&lid=LSTGSTGM6WSTRJHZU9FU55RWQ",
        burnerCount: 3,
      
        mrp: 5999,
        rating: 4.6,
        reviews: 15,
        description: `PNG stove with toughened glass top featuring three burners. Enhanced cooking capacity with robust construction.`,
        freeItems: [FREE_ITEMS.KNIFE],
        images: [
          require("../assets/3B/01.webp"),
          require("../assets/3B/02.webp"),
          require("../assets/3B/03.webp"),
          require("../assets/3B/04.webp"),
          require("../assets/3B/05.webp"),
          require("../assets/3B/06.webp"),
          require("../assets/3B/08.webp"),
          require("../assets/3B/09.webp"),
          require("../assets/3B/10.webp"),
          require("../assets/3B/11.webp")
        ],
        specs: [
          { label: "Material", value: "Toughened Glass Top" },
          { label: "Frame Thickness", value: "0.6 mm" },
          { label: "Frame Dimensions", value: "770mm x 380mm x 105mm" },
          { label: "Gas Pipe", value: "16 Gauge MS Pipe" },
          { label: "Gas Cock", value: "Manual Valve" },
          { label: "Pan Support", value: "240gm Powder Coated" },
          { label: "Brass Burner Top", value: "2 Big Burners 230gm each & 1 Small Burner 170gm" },
          { label: "Mixing Tube", value: "2 Big Tubes 235gm each & 1 Small Tube 210gm" },
          { label: "Dip Tray", value: "60gm each" },
          { label: "Leg Bush", value: "40mm" }
        ]
      },
      {
        sku: "GT004",
        title: "Glass Top - Four Burners",
        material: "Glass Top",
        flipkartUrl: "https://www.flipkart.com/realflame-burner-glass-top-gas-stove-manual-ignition/p/itm6cd856f8ce205?pid=GSTGM8FJDPZZ4AC5&lid=LSTGSTGM8FJDPZZ4AC5JDGEAQ",
        burnerCount: 4,
        mrp: 6999,
        rating: 4.8,
        reviews: 20,
        description: `PNG stove with toughened glass top featuring four burners. Maximum cooking capacity for large families and commercial use.`,
        freeItems: [FREE_ITEMS.KNIFE, FREE_ITEMS.LIGHTER],
        images: [
          require("../assets/4B/01.webp"),
          require("../assets/4B/02.webp"),
          require("../assets/4B/04.webp"),
          require("../assets/4B/05.webp"),
          require("../assets/4B/06.webp"),
          require("../assets/4B/07.webp"),
          require("../assets/4B/08.webp"),
          require("../assets/4B/09.webp"),
          require("../assets/4B/10.webp"),
          require("../assets/4B/011.webp"),
          require("../assets/4B/12.webp")
        ],
        specs: [
          { label: "Material", value: "Toughened Glass Top" },
          { label: "Frame Thickness", value: "0.6 mm" },
          { label: "Frame Dimensions", value: "585mm x 500mm x 105mm" },
          { label: "Gas Pipe", value: "16 Gauge MS Pipe" },
          { label: "Gas Cock", value: "Manual Valve" },
          { label: "Pan Support", value: "240gm Powder Coated" },
          { label: "Brass Burner Top", value: "2 Big Burners 230gm each & 2 Small Burners 170gm each" },
          { label: "Mixing Tube", value: "2 Big Tubes 235gm each & 2 Small Tubes 210gm each" },
          { label: "Dip Tray", value: "60gm each" },
          { label: "Leg Bush", value: "40mm" }
        ]
      },
      // Stainless Steel Variations
      {
        sku: "SS002",
        title: "Stainless Steel - Dual Burner",
        material: "Stainless Steel",
        flipkartUrl: "https://www.flipkart.com/realflame-stove-2-burner-stainless-steel-manual-gas/p/itm89377e0fc24ed",
        burnerCount: 2,
      
        mrp: 4999,
        rating: 4.4,
        reviews: 10,
        description: `PNG stove with premium stainless steel body featuring dual burners. Corrosion resistant and easy to maintain.`,
        freeItems: [FREE_ITEMS.LIGHTER],
        images: [
          require("../assets/2B SS/1.webp"),
          require("../assets/2B SS/2.webp"),
          require("../assets/2B SS/3.webp"),
          require("../assets/2B SS/4.webp"),
          require("../assets/2B SS/11.webp"),
          require("../assets/2B SS/12.webp"),
          require("../assets/2B SS/13.webp"),
          require("../assets/2B SS/14.webp")
        ],
        specs: [
          { label: "Material", value: "Premium Stainless Steel" },
          { label: "Body Thickness", value: "0.6 mm" },
          { label: "Body Dimension", value: "680mm x 345mm x 115mm" },
          { label: "Gas Pipe", value: "16 Gauge MS Pipe" },
          { label: "Gas Cock", value: "Manual Valve" },
          { label: "Pan Support", value: "240gm Powder Coated" },
          { label: "Brass Burner Top", value: "1 Big Burner 230gm & 1 Small Burner 170gm" },
          { label: "Mixing Tube", value: "1 Big Tube 235gm & 1 Small Tube 210gm" },
          { label: "Dip Tray", value: "60gm each" },
          { label: "Leg Bush", value: "40mm" }
        ]
      },
      {
        sku: "SS003",
        title: "Stainless Steel - Three Burner",
        material: "Stainless Steel",
        flipkartUrl: "https://www.flipkart.com/realflame-png-stove-3-burner-stainless-steel-manual-gas/p/itm001515bd6e6e4?pid=GSTHG3HSHGDJ6ZXG&lid=LSTGSTHG3HSHGDJ6ZXGAL5QJD",
        burnerCount: 3,
      
        mrp: 5999,
        rating: 4.5,
        reviews: 14,
        description: `PNG stove with premium stainless steel body featuring three burners. Professional grade construction for enhanced durability.`,
        freeItems: [FREE_ITEMS.KNIFE],
        images: [
          require("../assets/3B SS/5.webp"),
          require("../assets/3B SS/6.webp"),
          require("../assets/3B SS/7.webp"),
          require("../assets/3B SS/11.webp"),
          require("../assets/3B SS/12.webp"),
          require("../assets/3B SS/13.webp"),
          require("../assets/3B SS/14.webp")
        ],
        specs: [
          { label: "Material", value: "Premium Stainless Steel" },
          { label: "Body Thickness", value: "0.6 mm" },
          { label: "Body Dimensions", value: "790mm x 395mm x 115mm" },
          { label: "Gas Pipe", value: "16 Gauge MS Pipe" },
          { label: "Gas Cock", value: "Manual Valve" },
          { label: "Pan Support", value: "240gm Powder Coated" },
          { label: "Brass Burner Top", value: "2 Big Burners 230gm each & 1 Small Burner 170gm" },
          { label: "Mixing Tube", value: "2 Big Tubes 235gm each & 1 Small Tube 210gm" },
          { label: "Dip Tray", value: "60gm each" },
          { label: "Leg Bush", value: "40mm" }
        ]
      },
      {
        sku: "SS004",
        title: "Stainless Steel - Four Burners",
        material: "Stainless Steel",
        flipkartUrl: "https://www.flipkart.com/realflame-png-stove-4-burner-stainless-steel-manual-gas/p/itmf7b49d96e72da",
        burnerCount: 4,
      
        mrp: 6999,
        rating: 4.7,
        reviews: 18,
        description: `PNG stove with premium stainless steel body featuring four burners. Maximum capacity with professional grade construction.`,
        freeItems: [FREE_ITEMS.KNIFE, FREE_ITEMS.LIGHTER],
        images: [
          require("../assets/4B SS/8.webp"),
          require("../assets/4B SS/9.webp"),
          require("../assets/4B SS/10.webp"),
          require("../assets/4B SS/11.webp"),
          require("../assets/4B SS/12.webp"),
          require("../assets/4B SS/13.webp"),
          require("../assets/4B SS/14.webp")
        ],
        specs: [
          { label: "Material", value: "Premium Stainless Steel" },
          { label: "Body Thickness", value: "0.6 mm" },
          { label: "Body Dimensions", value: "600mm x 510mm x 115mm" },
          { label: "Gas Pipe", value: "16 Gauge MS Pipe" },
          { label: "Gas Cock", value: "Manual Valve" },
          { label: "Pan Support", value: "240gm Powder Coated" },
          { label: "Brass Burner Top", value: "2 Big Burners 230gm each & 2 Small Burners 170gm each" },
          { label: "Mixing Tube", value: "2 Big Tubes 235gm each & 2 Small Tubes 210gm each" },
          { label: "Dip Tray", value: "60gm each" },
          { label: "Leg Bush", value: "40mm" }
        ]
      }
    ]
  },

  // LPG Stove - Base Product with Variations
  {
    id: "lpg-stove",
    baseTitle: "LPG Stove",
    baseCategory: "lpg-stoves",
    baseDescription: "High-quality LPG stoves available in various configurations from single burner to four burner models.",
    baseImage: require("./productImage/lpg.png"),
    variations: [
      {
        sku: "LPG-NANO-001",
        title: "Single Burner Nano Model",
        burnerCount: 1,
        price: "Contact for Quote",
        rating: 4.3,
        reviews: 8,
        description: `Compact single burner LPG stove perfect for small kitchens and portable use.`,
        images: [require("./productImage/LPG Stove 1 Burner.jpg")],
        specs: [
          { label: "Burner Type", value: "Single Burner" },
          { label: "Fuel Type", value: "LPG" },
          { label: "Material", value: "Stainless Steel" },
          { label: "Dimensions", value: "300mm x 250mm x 80mm" }
        ]
      },
      {
        sku: "LPG-CLASSIC-002",
        title: "Double Burner Classic Model",
        burnerCount: 2,
        price: "Contact for Quote",
        rating: 4.4,
        reviews: 12,
        description: `Classic double burner LPG stove with stainless steel construction.`,
        images: [require("./productImage/LPG Stove 2 Burner.jpg")],
        specs: [
          { label: "Burner Type", value: "Double Burner" },
          { label: "Fuel Type", value: "LPG" },
          { label: "Material", value: "Stainless Steel" },
          { label: "Dimensions", value: "500mm x 300mm x 90mm" }
        ]
      },
      {
        sku: "LPG-GT003",
        title: "Glass Top Three Burner",
        burnerCount: 3,
        price: "Contact for Quote",
        rating: 4.6,
        reviews: 15,
        description: `Premium glass top LPG stove with three burners for enhanced cooking capacity.`,
        images: [require("./productImage/LPG Stove 3 Burner.jpg")],
        specs: [
          { label: "Burner Type", value: "Three Burner" },
          { label: "Fuel Type", value: "LPG" },
          { label: "Material", value: "Glass Top" },
          { label: "Dimensions", value: "770mm x 380mm x 105mm" }
        ]
      },
      {
        sku: "LPG-GT004",
        title: "Glass Top Four Burner",
        burnerCount: 4,
        price: "Contact for Quote",
        rating: 4.7,
        reviews: 18,
        description: `Premium glass top LPG stove with four burners for maximum cooking capacity.`,
        images: [require("./productImage/lpg.png")],
        specs: [
          { label: "Burner Type", value: "Four Burner" },
          { label: "Fuel Type", value: "LPG" },
          { label: "Material", value: "Glass Top" },
          { label: "Dimensions", value: "800mm x 500mm x 105mm" }
        ]
      }
    ]
  },

  // Accessories - Individual Products
  {
    id: "burner-top",
    baseTitle: "Burner Top",
    baseCategory: "accessories",
    baseDescription: "High-quality replacement burner top for various stove models.",
    baseImage: require("./productImage/burnerset.png"),
    variations: [
      {
        sku: "ACC-BURNER-TOP",
        title: "Replacement Part",
        price: "Contact for Quote",
        rating: 4.2,
        reviews: 6,
        description: `Premium replacement burner top compatible with most stove models.`,
        images: [require("./productImage/burnerset.png")],
        specs: [
          { label: "Material", value: "Brass" },
          { label: "Compatibility", value: "Most Stove Models" },
          { label: "Weight", value: "230gm" }
        ]
      }
    ]
  },
  {
    id: "burner-set",
    baseTitle: "Burner Set",
    baseCategory: "accessories",
    baseDescription: "Complete burner set for stove maintenance and replacement.",
    baseImage: require("./productImage/burner.jpeg"),
    variations: [
      {
        sku: "ACC-BURNER-SET",
        title: "Complete Set",
        price: "Contact for Quote",
        rating: 4.4,
        reviews: 8,
        description: `Complete burner set including all necessary components for stove maintenance.`,
        images: [require("./productImage/burner.jpeg")],
        specs: [
          { label: "Contents", value: "Burner Top, Mixing Tube, Dip Tray" },
          { label: "Material", value: "Brass & Steel" },
          { label: "Compatibility", value: "Most Stove Models" }
        ]
      }
    ]
  },
  {
    id: "aluminum-grill",
    baseTitle: "Aluminum Grill",
    baseCategory: "accessories",
    baseDescription: "Durable aluminum grill accessory for enhanced cooking options.",
    baseImage: require("./productImage/aluminiumgrill.png"),
    variations: [
      {
        sku: "ACC-ALU-GRILL",
        title: "Grill Accessory",
        price: "Contact for Quote",
        rating: 4.1,
        reviews: 5,
        description: `High-quality aluminum grill accessory for various cooking needs.`,
        images: [require("./productImage/aluminiumgrill.png")],
        specs: [
          { label: "Material", value: "Aluminum" },
          { label: "Dimensions", value: "300mm x 200mm" },
          { label: "Weight", value: "150gm" }
        ]
      }
    ]
  },
  {
    id: "rubber-hose",
    baseTitle: "Rubber Hose with Clamp",
    baseCategory: "accessories",
    baseDescription: "Safe and reliable gas connection hose with secure clamping system.",
    baseImage: require("./productImage/ruberhose.jpeg"),
    variations: [
      {
        sku: "ACC-RUBBER-HOSE",
        title: "Gas Connection",
        price: "Contact for Quote",
        rating: 4.3,
        reviews: 7,
        description: `High-quality rubber hose with secure clamp for safe gas connections.`,
        images: [require("./productImage/ruberhose.jpeg")],
        specs: [
          { label: "Material", value: "Rubber" },
          { label: "Length", value: "1.5 meters" },
          { label: "Diameter", value: "8mm" }
        ]
      }
    ]
  },
  {
    id: "gas-regulator",
    baseTitle: "Gas Regulator",
    baseCategory: "accessories",
    baseDescription: "Safety component for controlled gas flow and pressure regulation.",
    baseImage: require("./productImage/gas.png"),
    variations: [
      {
        sku: "ACC-REGULATOR",
        title: "Safety Component",
        price: "Contact for Quote",
        rating: 4.5,
        reviews: 9,
        description: `Premium gas regulator for safe and controlled gas flow.`,
        images: [require("./productImage/gas.png")],
        specs: [
          { label: "Type", value: "Gas Regulator" },
          { label: "Pressure", value: "0.5-2.0 kg/cm²" },
          { label: "Material", value: "Brass" }
        ]
      }
    ]
  },

  // Customization Options Section - UPDATED
  {
    id: "customization-options",
    baseTitle: "Customization Services",
    baseCategory: "customization",
    baseDescription: "Complete customization solutions for stove boxes, regulators, and hose pipes to match your brand requirements.",
    baseImage: require("./productImage/custom4.jpeg"),
    variations: [
      {
        sku: "CUSTOM-STOVE-BOXES",
        title: "Customized Stove Boxes",
        price: "Quote on Request",
        rating: 5.0,
        reviews: 0,
        description: `Transform your packaging into a powerful branding tool. We offer fully customizable stove boxes that go beyond simple packaging - include your company's vision, mission, social messages, safety instructions, or even interactive games to engage your customers. Additionally, we provide brand name embossing on stoves and customized stickers to ensure perfect alignment with your brand identity.`,
        images: [
          require("./productImage/custom1.jpeg"),
          require("./productImage/custom2.jpeg"),
          require("./productImage/custom3.jpeg"),
          require("./productImage/custom4.jpeg"),
          require("./productImage/custom5.jpeg"),
          require("./productImage/custom6.jpeg"),
           require("./productImage/custom7.jpeg"),
          require("./productImage/custom8.jpeg"),
          require("./productImage/custom9.jpeg"),
           require("./productImage/custom10.jpeg"),
          require("./productImage/custom11.jpeg"),
          require("./productImage/custom12.jpeg"),
           require("./productImage/custom13.jpeg"),
          require("./productImage/custom14.jpeg"),
          require("./productImage/custom15.jpeg"),
        ],
        specs: [
          { label: "Minimum Order Quantity", value: "5,000 pcs" },
          { label: "Customization Type", value: "Complete Packaging Solution" },
          { label: "Lead Time", value: "Contact for Details" },
          { label: "Design Support", value: "Available" }
        ],
        customization: {
          features: [
            "Print company vision, mission, and core values on packaging",
            "Include social messages and comprehensive safety instructions",
            "Add interactive elements like puzzles or games for customer engagement",
            "Brand name embossing directly on stoves for lasting brand presence",
            "Custom stickers and labels perfectly aligned with your brand guidelines",
            "High-quality printing with durable, eco-friendly materials",
            "Flexible design options to match your marketing campaigns"
          ],
          note: "Private & Confidential – Design specifications and branding materials are handled with complete confidentiality"
        }
      },
      {
        sku: "CUSTOM-REGULATOR",
        title: "Custom Gas Regulator",
        price: "Quote on Request",
        rating: 5.0,
        reviews: 0,
        description: `Design gas regulators that perfectly represent your brand. Choose your brand name, customize technical specifications to meet your market needs, and select stove colors that complement your product line. Every aspect can be tailored to maintain consistency with your overall brand design and quality standards.`,
        images: [
          require("./productImage/regulator.png"),
        ],
        specs: [
          { label: "Minimum Order Quantity", value: "5,000 pcs" },
          { label: "Customization Type", value: "Complete Regulator Customization" },
          { label: "Lead Time", value: "Contact for Details" },
          { label: "Technical Support", value: "Available" }
        ],
        customization: {
          features: [
            "Custom brand name engraving or embossing on regulators",
            "Tailor technical specifications to match regional requirements",
            "Choose from multiple stove color options to match your product aesthetics",
            "Quality certifications and compliance documentation as per your market",
            "Customizable pressure settings and valve configurations",
            "Logo placement options on multiple regulator components",
            "Color-coded designs for easy product differentiation"
          ],
          note: "Private & Confidential – All technical specifications and brand customizations are protected under NDA"
        }
      },
      {
        sku: "CUSTOM-HOSE-PIPE",
        title: "Custom Hose Pipe with Clamp",
        price: "Quote on Request",
        rating: 5.0,
        reviews: 0,
        description: `Customize gas hose pipes to your exact requirements. Select your preferred length for optimal installation flexibility, and add your branding as a continuous running line along the entire hose. This ensures your brand visibility throughout the product's lifecycle. Please note that hose color is standardized for safety compliance and cannot be modified.`,
        images: [
          require("./productImage/clamp.png"),
        ],
        specs: [
          { label: "Minimum Order Quantity", value: "2,000 metres" },
          { label: "Customization Type", value: "Length and Branding" },
          { label: "Lead Time", value: "Contact for Details" },
          { label: "Standard Features", value: "Quality Clamps Included" }
        ],
        customization: {
          features: [
            "Fully customizable length from 0.5 meters to 3 meters or as per requirement",
            "Brand name printed as continuous running line along entire hose length",
            "High-visibility branding that remains intact throughout product use",
            "Premium quality rubber material with extended durability",
            "Secure clamp system included with every hose",
            "Safety-compliant materials meeting international standards",
            "Bulk packaging options available for distributors"
          ],
          limitations: [
            "Hose pipe color is fixed (standard black/grey) and cannot be changed due to safety and regulatory compliance"
          ],
          note: "Private & Confidential – Branding specifications are handled securely"
        }
      }
    ]
  }
];

export default products;